module.exports = __webpack_public_path__ + "img/about-bg.e30aa04a.png";